<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.title`
        )
      }}
    </h1>
    <p>
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.paragraph1`
        )
      }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="pic1Name" />
    <br />
    <p>
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.paragraph2`
        )
      }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="pic2Name" />
    <v-img style="width: 100%; max-width: 600px" contain :src="pic3Name" />
    <br />
    <p>
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.paragraph3`
        )
      }}
    </p>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['isEmpresaUser']),
    pic1Name() {
      return require('@/assets/documentation/companies/' +
        this.$t(
          `documentation.texts.${
            this.isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.pic1`
        ) +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/companies/' +
        this.$t(
          `documentation.texts.${
            this.isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.pic2`
        ) +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/companies/' +
        this.$t(
          `documentation.texts.${
            this.isEmpresaUser ? 'companiesGD' : 'companies'
          }.update.pic3`
        ) +
        '.png')
    },
  },
  methods: {
    goDoc(section, subsection = '') {
      if (subsection === '')
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section },
        })
      else
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section, subsection },
        })
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
